import { useInfiniteQuery } from "@tanstack/react-query";
import { apiClient } from "../config/api-client";
import { API_ENDPOINTS } from "../config/api-endpoints";
import type {
  LoginHistoryResponse,
  LoginHistoryParams,
} from "../models/api-types";

/**
 * Hook to fetch login history with infinite scroll
 * @param params - Optional pagination parameters
 * @returns Infinite query result with login history data
 */
export const useLoginHistory = (params?: LoginHistoryParams) => {
  return useInfiniteQuery<LoginHistoryResponse>({
    queryKey: ["loginHistory", params],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await apiClient.get(API_ENDPOINTS.loginHistory, {
        params: {
          ...params,
          page: pageParam,
          limit: params?.limit || 10,
        },
      });
      return (response as any).data;
    },
    getNextPageParam: (lastPage, allPages) => {
      const currentPage = allPages.length;
      const totalPages = lastPage.meta?.totalPage || 0;

      // Eğer daha fazla sayfa varsa next page'i döndür
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    initialPageParam: 1,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10, // 10 minutes
  });
};
